<div class="main-db gap-top">
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="col-12 col-sm-10">
        <h1>Interactive</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-2">
        <!-- <div class="float-left ml-1" *ngFor="let geofence of data">
          <button class="btn btn-success" (click)="getAllGeofenceZone(geofence.geofenceId)">{{geofence.geofenceName}}</button>
        </div> -->
          <h2>Select Geofence</h2>
        <mat-select class="form form-control">
          <mat-option *ngFor="let geofence of data" [(value)]="geofence.geofenceId" (click)="getAllGeofenceZone(geofence.geofenceId)">
            {{geofence.geofenceName}}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-12 mt-2">
<!--         
        <div cdkDropListGroup>
          <div class="example-container">
            <h2>To do</h2>
        
            <div
              cdkDropList
              [cdkDropListData]="selectedZone"
              class="example-list"
              (cdkDropListDropped)="drop($event)">
              <div class="example-box" *ngFor="let item of selectedZone" cdkDrag>{{item}}</div>
            </div>
          </div>
        
          <div class="example-container">
            <h2>Done</h2>
        
            <div
              cdkDropList
              [cdkDropListData]="geofenceZoneData"
              class="example-list"
              (cdkDropListDropped)="drop($event)">
              <div class="example-box" *ngFor="let item of geofenceZoneData" cdkDrag>{{item.zoneId}}</div>
            </div>
          </div>
        </div> -->
        <div cdkDropListGroup>
          <div class="example-container">
            <h2>Zone</h2>
        
            <div
              cdkDropList
              [cdkDropListData]="selectedZone"
              cdkDropListConnectedTo="myZone"
              class="example-list"
              (cdkDropListDropped)="drop($event)">
              <div class="example-box" *ngFor="let zoneId of selectedZone" cdkDrag>{{getZoneName(zoneId)}}</div>
            </div>
          </div>
        
          <div class="example-container">
            <h2>Zone in Current Geofence</h2>
        
            <div
              cdkDropList
              [cdkDropListData]="myZone"
              cdkDropListConnectedTo="selectedZone"
              class="example-list"
              (cdkDropListDropped)="drop($event)">
              <div class="example-box" *ngFor="let zoneId of myZone" cdkDrag>{{getZoneName(zoneId)}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <button class="btn btn-success" (click)="deleteGeofenceZoneByGeofenceId(myGeofenceId)">Save</button>
      </div>
    </div>
  </div>
</div>

